import { render, staticRenderFns } from "./SubAccounts.vue?vue&type=template&id=1f4f0320&scoped=true"
import script from "./SubAccounts.vue?vue&type=script&lang=js"
export * from "./SubAccounts.vue?vue&type=script&lang=js"
import style0 from "./SubAccounts.vue?vue&type=style&index=0&id=1f4f0320&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4f0320",
  null
  
)

export default component.exports